module.exports = __webpack_public_path__ + "static/media/header_admin.c95e15c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dermato/header_admin.jpg
// module id = 793
// module chunks = 1